/* The "Getting around the map" card's lines (SQ-621). */

/** Android's lines; on a computer the two that name a finger say what the mouse does. */
export const hintLines = (canEdit: boolean, mouse: boolean): string[] => {
  const zoom = mouse ? 'Scroll to zoom.' : 'Pinch to zoom.';
  return canEdit
    ? [
      'Use the plus button to add menu items to the map.',
      mouse ? 'Click and drag to move anything on the map.' : 'Touch and drag to move anything on the map.',
      'Tap an icon to open it.',
      'Tap a machine or gate to connect work items (tree, stump, etc.) to it.',
      'Drag anywhere else to move the map.',
      zoom,
    ]
    : ['Tap an icon to open it.', 'Drag to move the map.', zoom];
};
